module.exports = __webpack_public_path__ + "img/beer_id-33.41446890.png";